import { useRecoilValue } from 'recoil';

import { Badge } from '@/components/badge';
import { CarrierLogo } from '@/components/carrier-logo';
import { Text } from '@/components/text';
import { MODE_WATER } from '@/lib/constants';
import { getCarrierName } from '@/lib/models/carrier/utils/get-carrier-name';
import { LineModel } from '@/lib/models/lines/types';
import { carriersState } from '@/state/carriers';
import { getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

export interface LineCarriersProps {
  line: LineModel;
}

const LineCarriers = ({ line }: LineCarriersProps) => {
  const carrierDictionary = useRecoilValue(carriersState);
  const carrierServiceList = line.sharedCarriers.map((service) => {
    return {
      ...service,
      carrier: carrierDictionary[service.carrierId],
      isOperator: line.operatingCarrierIds.includes(service.carrierId),
    };
  });

  const { table, footerText, carrierName, th, td } = styles();

  return (
    <div>
      <table className={table()}>
        <tr>
          <th className={th()}>Carrier</th>
          <th className={th()}>Service Name</th>
        </tr>
        {carrierServiceList.map((item) => {
          const { carrier, serviceName } = item;
          const carrierCode = getPreferredIdentifier(carrier.identifiers)?.value || '';

          return (
            <tr key={item.carrierId}>
              <td className={td()}>
                <div className={carrierName()}>
                  <CarrierLogo carrierCode={carrierCode} mode={MODE_WATER} size="md" />
                  <span>
                    {getCarrierName(item.carrier)}
                    <b>{item.isOperator && ' *'}</b>
                  </span>
                </div>
              </td>
              <td className={td()}>
                <Badge variant="light" size="md">
                  {serviceName}
                </Badge>
              </td>
            </tr>
          );
        })}
      </table>
      <Text variant="sm" className={footerText()}>
        * Indicates operating carrier
      </Text>
    </div>
  );
};

const styles = tv({
  slots: {
    table: 'w-full text-baseSm',
    th: 'text-left font-medium',
    td: 'w-1/2 px-0 py-2',
    carrierName: 'flex items-center gap-3 whitespace-nowrap',
    footerText: 'mt-2 italic text-text-secondary',
  },
});

export { LineCarriers };
